import {
  BuildingOffice2Icon, // Office
  FilmIcon, // Studio
  BeakerIcon, // Science lab
  MusicalNoteIcon, // Music studio
  CameraIcon, // Photography studio
  HomeModernIcon, // Kitchen (using home icon as approximation)
  BuildingStorefrontIcon, // Shop front
  BuildingLibraryIcon, // Shared office
  BuildingOfficeIcon, // Private office
  CubeIcon, // Warehouse
  WrenchScrewdriverIcon, // Workshop
  ComputerDesktopIcon, // Coworking space
  PresentationChartBarIcon, // Meeting room
  BookOpenIcon, // Library/study space
} from "@heroicons/react/24/outline";

import { GoPeople } from "react-icons/go";
import { GiFlexibleLamp } from "react-icons/gi";
import { FiFastForward } from "react-icons/fi";
import { IoBusinessOutline } from "react-icons/io5";

const workspaceTypes = [
  {
    value: null,
    title: "",
    description: "",
    hoverDescription: "",
    image: null,
  },
  {
    value: 1,
    title: "Private Office",
    description: "Dedicated private offices for individuals or small teams.",
    hoverDescription:
      "Lockable private spaces with desks, storage, and meeting areas.",
    image: BuildingOfficeIcon,
  },
  {
    value: 2,
    title: "Shared Office",
    description: "Open-plan workspaces shared with other professionals.",
    hoverDescription:
      "Cost-effective solution with shared amenities and networking opportunities.",
    image: BuildingLibraryIcon,
  },
  {
    value: 3,
    title: "Coworking desk",
    description: "Flexible desk space in a shared environment.",
    hoverDescription:
      "Hot desks with access to communal facilities and networking events.",
    image: GoPeople,
  },
  {
    value: 4,
    title: "Enterprise Suite",
    description: "Enterprise-level office spaces for larger teams.",
    hoverDescription:
      "Customizable layouts with dedicated amenities for larger organizations.",
    image: IoBusinessOutline,
  },
  {
    value: 5,
    title: "Serviced Office",
    description:
      "Fully furnished and equipped office spaces with flexible terms.",
    hoverDescription:
      "All-inclusive packages with utilities, internet, and office services.",
    image: GiFlexibleLamp,
  },
  {
    value: 6,
    title: "Sublet Office Space",
    description: "Sublet office spaces for short-term use.",
    hoverDescription:
      "Flexible arrangements for businesses needing temporary office space.",
    image: FiFastForward,
  },
  {
    value: 7,
    title: "Creative Studio",
    description: "Spaces designed for creative professionals and artists.",
    hoverDescription:
      "Natural light, high ceilings, and specialized equipment for creative work.",
    image: FilmIcon,
  },
  {
    value: 8,
    title: "Music Studio",
    description: "Acoustically treated spaces for recording and rehearsal.",
    hoverDescription: "Soundproof rooms with professional audio equipment.",
    image: MusicalNoteIcon,
  },
  {
    value: 9,
    title: "Photography Studio",
    description: "Spaces equipped for professional photography.",
    hoverDescription: "Backdrops, lighting equipment, and shooting spaces.",
    image: CameraIcon,
  },
  {
    value: 10,
    title: "Science Lab",
    description: "Specialized laboratories for research and development.",
    hoverDescription:
      "Equipped with lab benches, fume hoods, and specialized equipment.",
    image: BeakerIcon,
  },
  {
    value: 11,
    title: "Commercial Kitchen",
    description: "Fully-equipped kitchens for food businesses.",
    hoverDescription:
      "Industrial appliances, prep areas, and storage for food service.",
    image: HomeModernIcon,
  },
  {
    value: 12,
    title: "Warehouse",
    description: "Large storage and distribution spaces.",
    hoverDescription:
      "High ceilings, loading docks, and open floor plans for inventory.",
    image: CubeIcon,
  },
  {
    value: 13,
    title: "Shop Front",
    description: "Retail spaces with street visibility.",
    hoverDescription: "Storefronts with display windows and customer areas.",
    image: BuildingStorefrontIcon,
  },
  {
    value: 14,
    title: "Entire Floor (Office)",
    description: "Complete office floors for larger organizations.",
    hoverDescription:
      "Customizable layouts for departments or entire companies.",
    image: BuildingOffice2Icon,
  },
  {
    value: 15,
    title: "Coworking Space",
    description: "Flexible memberships for individuals and teams.",
    hoverDescription: "Community spaces with hot desks and shared amenities.",
    image: ComputerDesktopIcon,
  },
  {
    value: 16,
    title: "Workshop",
    description: "Spaces for fabrication and hands-on work.",
    hoverDescription: "Tool benches, equipment, and workspace for makers.",
    image: WrenchScrewdriverIcon,
  },
  {
    value: 17,
    title: "Meeting Room",
    description: "Professional spaces for presentations and collaboration.",
    hoverDescription: "Equipped with AV systems and conference tables.",
    image: PresentationChartBarIcon,
  },
  {
    value: 18,
    title: "Study Space",
    description: "Quiet areas for focused individual work.",
    hoverDescription: "Peaceful environments with desks and reading areas.",
    image: BookOpenIcon,
  },
];

export default workspaceTypes;
